import { TranslationConfig } from 'react-utilities';

export const FEATURE_NAME = 'SecurityQuestions' as const;
export const LOG_PREFIX = 'Security Questions:' as const;

/**
 * Translations required by this web app (remember to also edit
 * `bundle.config.js` if changing this configuration).
 */
export const TRANSLATION_CONFIG: TranslationConfig = {
  common: [],
  feature: 'Feature.SecurityQuestions'
};

/**
 * Constants for event stream events.
 */
export const EVENT_CONSTANTS = {
  eventName: 'securityQuestionsEvent',
  context: {
    answerChoicesFailedToLoad: 'answerChoicesFailedToLoad'
  }
} as const;

/**
 * Language resource keys for security questions that are requested
 * dynamically.
 */
export const SECURITY_QUESTIONS_LANGUAGE_RESOURCES = [
  'Action.Confirm',
  'Action.PickN',
  'Action.PleaseTryAgain',
  'Action.Reload',
  'Action.SelectAllThatApply',
  'Description.UnknownChoice',
  'Description.VerifyYourIdentity',
  'Description.WhichGames',
  'Header.PleaseConfirmYourIdentity',
  'Message.Error.Default',
  'Message.Error.MustPickN',
  'Message.Error.SecurityQuestions.SessionInactive'
] as const;
